<template>
  <div class="topbar">
    <div class="left-content">
      <hamburger :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container"/>
      <img src="../../../assets/image/indexs/index-logo.png" alt="" class=""
           style="width: 44px;height: 44px;margin-right: 5px;">
      <div class="left-title">农业物联网信息系统</div>

      <el-dropdown class="left-dropdown" trigger="click" v-if="type!=2">
        <span class="el-dropdown-link">
          {{ found_name }}<i class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item in baseList" :key="item.id">
            <div @click="changeBase(item.id)">{{ item.found_name }}</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown class="left-dropdown" trigger="click" v-if="type!=2">
        <span class="el-dropdown-link">
          {{ plot_name }}<i class="el-icon-caret-bottom"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item in plotList" :key="item.id">
            <div @click="changePlot(item.id)">{{ item.plot_name }}</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <!-- <el-select v-model="found_id" class="left-dropdown">
        <el-option
            v-for="item in baseList"
            :key="item.id"
            :label="item.found_name"
            :value="item.id">
        </el-option>
      </el-select> -->

      <!-- <el-select v-model="plot_id" class="left-dropdown">
        <el-option
            v-for="item in plotList"
            :key="item.id"
            :label="item.plot_name"
            :value="item.id">
        </el-option>
      </el-select> -->
    </div>

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <div class="now-time" style="position: relative;top: 2px">
          <iframe allowtransparency="true" frameborder="0" width="317" height="28" scrolling="no"
                  src="//tianqi.2345.com/plugin/widget/index.htm?s=3&z=1&t=1&v=0&d=1&bd=0&k=&f=ffffff&ltf=ffffff&htf=ffffff&q=1&e=0&a=1&c=57494&w=317&h=28&align=left"></iframe>
        </div>
        <div class="now-time">{{ nowTime }}</div>
      </template>

      <el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          <img :src="userImg+'?imageView2/1/w/80/h/80'" class="user-avatar">
          <span>{{ name }}</span>
          <i class="el-icon-caret-bottom"/>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/" v-if="type!=2">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <router-link to="/useredit" v-if="type!=1">
            <el-dropdown-item :divided="type!=2">
              修改个人资料
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <router-link to="/message" v-if="type!=2">
        <div class="message-wrap">
          <img src="../../../assets/image/indexs/information.png" class="set-img"/>
          <!-- <span class="msg-icon">1</span> -->
        </div>
      </router-link>
      <router-link to="/setting" v-if="type!=2">
        <img src="../../../assets/image/indexs/in-set.png" class="set-img"/>
      </router-link>

    </div>
  </div>
</template>

<script>
import { getFoundOption, getFoundPlotList, displayMenuByDevice, readDevice6Link } from '@/api/set.js'
import { path } from '@/api/set.js'
import Hamburger from '@/components/Hamburger'
import userImg from '@/assets/image/admin.png'
import { mapGetters } from 'vuex'
import {
  getFoundId,
  setFoundId,
  getPlotId,
  setPlotId,
  setPlotName,
  getUserId,
  getType,
  getPlotName,
} from '@/utils/auth'

export default {
  name: 'topbar',
  components: {
    Hamburger,
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'avatar',
      'device',
      'foundId',
      'plotId',
      'loading',
    ]),
  },
  data () {
    return {
      path: path,
      nowTime: '',
      timer: '',
      userImg: userImg,
      found_id: '',
      found_name: '',
      plot_id: '',
      plot_name: '',
      baseList: [],
      plotList: [],
      type: 1,
    }
  },
  created () {
    this.type = getType()
    if (this.type == 2) {
      this.$router.options.routes[6].hidden = true
      this.$router.options.routes[7].hidden = true
      this.$router.options.routes[8].hidden = true
      this.$router.options.routes[9].hidden = true
      this.$router.options.routes[10].hidden = true
    } else {
      this.$router.options.routes[6].hidden = false
      this.$router.options.routes[7].hidden = false
      this.$router.options.routes[8].hidden = false
      this.$router.options.routes[9].hidden = false
      this.$router.options.routes[10].hidden = false
    }
    if (this.avatar) {
      this.userImg = this.path + this.avatar
    }
    this.currentTime()
    if (getUserId() && getType() != 2) {
      this.getBaseOption()
    }
  },
  activated () {
    if (getUserId() && getType() != 2) {
      this.found_id = getFoundId()
      let baseObj = this.baseList.filter((item, index) => {
        return item.id == this.found_id
      })
      this.found_name = baseObj[0].found_name
      this.plot_name = getPlotName()
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    toggleSideBar () {
      this.$store.dispatch('toggleSideBar')
    },
    getTime () {
      const yy = new Date().getFullYear()
      const mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1)
      const dd = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
      const hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
      const mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      const week = new Date().getDay()
      const weekList = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      this.nowTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss + ' ' + weekList[week]
    },
    currentTime () {
      this.timer = setInterval(this.getTime, 500)
    },
    logout () {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      })
    },
    // 获取基地选项
    getBaseOption () {
      this.$store.commit('SET_LOADING', true)
      getFoundOption({ user_id: getUserId() }).then(res => {
        this.baseList = res.data.data
        if (getFoundId()) {
          this.found_id = getFoundId()
          let baseObj = this.baseList.filter((item, index) => {
            return item.id == this.found_id
          })
          this.found_name = baseObj[0].found_name
        } else {
          this.found_id = this.baseList[0].id
          this.found_name = this.baseList[0].found_name
        }
        this.$store.commit('SET_FOUNDID', this.found_id)
        setFoundId(this.found_id)
        this.getPlotOptionFirst()
      })
    },
    // 获取地块选项
    getPlotOptionFirst () {
      getFoundPlotList({ user_id: getUserId(), found_id: this.found_id }).then(res => {
        this.plotList = res.data.data
        let pList = this.plotList.map((item, index) => {
          return item.id
        })
        let pid = Number(getPlotId())
        if (getPlotId() && pList.includes(pid)) {
          this.plot_id = getPlotId()
          let plotObj = this.plotList.filter((item, index) => {
            return item.id == this.plot_id
          })
          this.plot_name = plotObj[0].plot_name
        } else {
          this.plot_id = this.plotList[0].id
          this.plot_name = this.plotList[0].plot_name
        }
        this.$store.commit('SET_PLOTID', this.plot_id)
        setPlotId(this.plot_id)
        setPlotName(this.plot_name)
        readDevice6Link({ user_id: getUserId(), plot_id: this.plot_id }).then(res => {
          this.$router.options.routes[7].children[1].children[1].path = res.data.data
        })
        displayMenuByDevice({ user_id: getUserId(), plot_id: this.plot_id }).then(res => {
          let resData = res.data.data
          if (resData.includes('气象设备')) {
            this.$router.options.routes[7].children[0].children[0].hidden = false
          } else {
            this.$router.options.routes[7].children[0].children[0].hidden = true
          }
          if (resData.includes('墒情设备')) {
            this.$router.options.routes[7].children[0].children[1].hidden = false
          } else {
            this.$router.options.routes[7].children[0].children[1].hidden = true
          }
          if ((!resData.includes('气象设备')) && (!resData.includes('墒情设备'))) {
            this.$router.options.routes[7].children[0].hidden = true
          } else {
            this.$router.options.routes[7].children[0].hidden = false
          }
          if (resData.includes('性诱设备')) {
            this.$router.options.routes[7].children[1].children[0].hidden = false
          } else {
            this.$router.options.routes[7].children[1].children[0].hidden = true
          }
          if (resData.includes('光诱设备')) {
            this.$router.options.routes[7].children[1].children[1].hidden = false
          } else {
            this.$router.options.routes[7].children[1].children[1].hidden = true
          }
          if (resData.includes('新虫情设备')) {
            this.$router.options.routes[7].children[1].children[2].hidden = false
          } else {
            this.$router.options.routes[7].children[1].children[2].hidden = true
          }
          if ((!resData.includes('性诱设备')) && (!resData.includes('光诱设备')) && (!resData.includes('新虫情设备'))) {
            this.$router.options.routes[7].children[1].hidden = true
          } else {
            this.$router.options.routes[7].children[1].hidden = false
          }
          if (resData.includes('长势设备')) {
            this.$router.options.routes[7].children[2].hidden = false
          } else {
            this.$router.options.routes[7].children[2].hidden = true
          }
          if (resData.includes('实时监控')) {
            this.$router.options.routes[7].children[3].hidden = false
          } else {
            this.$router.options.routes[7].children[3].hidden = true
          }
          this.$store.commit('SET_LOADING', false)
        })
      })
    },
    // 获取地块选项
    getPlotOption () {
      getFoundPlotList({ user_id: getUserId(), found_id: this.found_id }).then(res => {
        this.plotList = res.data.data
        this.plot_id = this.plotList[0].id
        this.$store.commit('SET_PLOTID', this.plot_id)
        setPlotId(this.plot_id)
        this.plot_name = this.plotList[0].plot_name
        setPlotName(this.plot_name)
        this.$store.commit('SET_LOADING', true)
        readDevice6Link({ user_id: getUserId(), plot_id: this.plot_id }).then(res => {
          this.$router.options.routes[7].children[1].children[1].path = res.data.data
        })
        displayMenuByDevice({ user_id: getUserId(), plot_id: this.plot_id }).then(res => {
          let resData = res.data.data
          if (resData.includes('气象设备')) {
            this.$router.options.routes[7].children[0].children[0].hidden = false
          } else {
            this.$router.options.routes[7].children[0].children[0].hidden = true
          }
          if (resData.includes('墒情设备')) {
            this.$router.options.routes[7].children[0].children[1].hidden = false
          } else {
            this.$router.options.routes[7].children[0].children[1].hidden = true
          }
          if ((!resData.includes('气象设备')) && (!resData.includes('墒情设备'))) {
            this.$router.options.routes[7].children[0].hidden = true
          } else {
            this.$router.options.routes[7].children[0].hidden = false
          }
          if (resData.includes('性诱设备')) {
            this.$router.options.routes[7].children[1].children[0].hidden = false
          } else {
            this.$router.options.routes[7].children[1].children[0].hidden = true
          }
          if (resData.includes('光诱设备')) {
            this.$router.options.routes[7].children[1].children[1].hidden = false
          } else {
            this.$router.options.routes[7].children[1].children[1].hidden = true
          }
          if ((!resData.includes('性诱设备')) && (!resData.includes('光诱设备'))) {
            this.$router.options.routes[7].children[1].hidden = true
          } else {
            this.$router.options.routes[7].children[1].hidden = false
          }
          if (resData.includes('长势设备')) {
            this.$router.options.routes[7].children[2].hidden = false
          } else {
            this.$router.options.routes[7].children[2].hidden = true
          }
          if (resData.includes('实时监控')) {
            this.$router.options.routes[7].children[3].hidden = false
          } else {
            this.$router.options.routes[7].children[3].hidden = true
          }
          this.$store.commit('SET_LOADING', false)

          let routerList = []
          this.$router.options.routes[7].children.forEach((item, index) => {
            for (let i = 0; i < item.children.length; i++) {
              routerList.push(item.children[i])
            }
          })
          let list = routerList.filter(item => {
            return item.name == this.$router.history.current.name
          })
          if (list.length > 0 && list[0].hidden) {
            this.$router.push({ path: '/setting' })
          }
        })
      })
    },
    // 切换基地
    changeBase (id) {
      if (this.found_id == id) {
        return
      }
      this.found_id = id
      this.$store.commit('SET_FOUNDID', this.found_id)
      setFoundId(this.found_id)
      let baseObj = this.baseList.filter((item, index) => {
        return item.id == id
      })
      this.found_name = baseObj[0].found_name
      this.getPlotOption()
    },
    // 切换地块
    changePlot (id) {
      if (this.plot_id == id) {
        return
      }
      this.plot_id = id
      this.$store.commit('SET_PLOTID', this.plot_id)
      setPlotId(this.plot_id)
      this.$store.commit('SET_LOADING', true)
      readDevice6Link({ user_id: getUserId(), plot_id: this.plot_id }).then(res => {
        this.$router.options.routes[7].children[1].children[1].path = res.data.data
      })
      displayMenuByDevice({ user_id: getUserId(), plot_id: this.plot_id }).then(res => {
        let resData = res.data.data
        if (resData.includes('气象设备')) {
          this.$router.options.routes[7].children[0].children[0].hidden = false
        } else {
          this.$router.options.routes[7].children[0].children[0].hidden = true
        }
        if (resData.includes('墒情设备')) {
          this.$router.options.routes[7].children[0].children[1].hidden = false
        } else {
          this.$router.options.routes[7].children[0].children[1].hidden = true
        }
        if ((!resData.includes('气象设备')) && (!resData.includes('墒情设备'))) {
          this.$router.options.routes[7].children[0].hidden = true
        } else {
          this.$router.options.routes[7].children[0].hidden = false
        }
        if (resData.includes('性诱设备')) {
          this.$router.options.routes[7].children[1].children[0].hidden = false
        } else {
          this.$router.options.routes[7].children[1].children[0].hidden = true
        }
        if (resData.includes('光诱设备')) {
          this.$router.options.routes[7].children[1].children[1].hidden = false
        } else {
          this.$router.options.routes[7].children[1].children[1].hidden = true
        }
        if ((!resData.includes('性诱设备')) && (!resData.includes('光诱设备'))) {
          this.$router.options.routes[7].children[1].hidden = true
        } else {
          this.$router.options.routes[7].children[1].hidden = false
        }
        if (resData.includes('长势设备')) {
          this.$router.options.routes[7].children[2].hidden = false
        } else {
          this.$router.options.routes[7].children[2].hidden = true
        }
        if (resData.includes('实时监控')) {
          this.$router.options.routes[7].children[3].hidden = false
        } else {
          this.$router.options.routes[7].children[3].hidden = true
        }
        this.$store.commit('SET_LOADING', false)

        let routerList = []
        this.$router.options.routes[7].children.forEach((item, index) => {
          for (let i = 0; i < item.children.length; i++) {
            routerList.push(item.children[i])
          }
        })
        let list = routerList.filter(item => {
          return item.name == this.$router.history.current.name
        })
        if (list.length > 0 && list[0].hidden) {
          this.$router.push({ path: '/setting' })
        }
      })
      let plotObj = this.plotList.filter((item, index) => {
        return item.id == id
      })
      this.plot_name = plotObj[0].plot_name
      setPlotName(this.plot_name)
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.topbar {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 68px;
  background: #008B90;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 24px;
  color: #ffffff;

  .left-content {
    display: flex;
    align-items: center;

    .hamburger-container {
      margin-right: 15px;
    }
  }

  .left-dropdown {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
    color: #FFFFFF;
    margin-left: 50px;
    cursor: pointer;
    border: 1px solid rgba($color: #FFFFFF, $alpha: 0.5);
    padding: 0 10px;

    .el-icon-caret-bottom {
      color: #ffffff;
      font-size: 12px;
      margin-left: 5px;
    }
  }

  .right-menu {
    display: flex;
    align-items: center;
    height: 100%;

    .now-time {
      font-size: 14px;
      margin-right: 30px;
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      margin: 0 8px;
      vertical-align: top;
    }

    .message {
      position: relative;
      top: -3px;
    }

    .avatar-container {
      height: 50px;
      margin-right: 30px;

      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;

        span {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 19px;
          color: #FFFFFF;
          margin-left: 5px;
        }

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .el-icon-caret-bottom {
          color: #ffffff;
          position: absolute;
          right: -20px;
          top: 15px;
          font-size: 12px;
        }
      }
    }

    .set-img {
      cursor: pointer;
    }
  }

  .message-wrap {
    position: relative;
    margin-right: 10px;

    .msg-icon {
      position: absolute;
      top: 0;
      right: 0;
      min-width: 16px;
      height: 16px;
      background: #E52222;
      border-radius: 50%;
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      line-height: 16px;
      transform: translate(50%, -50%);
    }
  }
}
</style>

<style lang="scss">
.topbar {
  .left-dropdown {
    .el-input__inner {
      background: transparent;
      color: #fff;
      border: none;
      size: 20px;
    }
  }
}
</style>
